import {FlavourNote} from '../types';
import {axiosClient} from '../axios';
import {getViewKeyHeader} from '../utils';

export const getFlavourNotes = async (viewKey?: string) => {
  const {data} = await axiosClient.get<ReadonlyArray<FlavourNote>>(
    '/flavour-notes/',
    {headers: getViewKeyHeader(viewKey)},
  );
  return data;
};
